import { styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled.button`
    ${styledReset.button}

    border-radius: 40px;
    background: radial-gradient(67.31% 175% at 50% 148.75%, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0) 100%),
        rgba(255, 255, 255, 0.05);

    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.28px;

    width: 100%;
    height: 40px;

    transition: box-shadow 200ms ease;

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }
`;
